import './i18n';
import 'reflect-metadata';
import 'regenerator-runtime';
import { AuthenticationProvider } from '@interhyp/platform-auth';
import { DevtoolsProvider } from '@interhyp/platform-devtools';
import { FooterContext } from '@interhyp/platform-layout';
import { MetaProvider } from '@interhyp/platform-meta';
import { ModuleProvider } from '@interhyp/platform-module';
import { NotificationProvider } from '@interhyp/platform-notification';
import { BrowserRouter } from '@interhyp/platform-router';
import { StorageProvider } from '@interhyp/platform-storage';
import { InternalTracking, TrackingProvider } from '@interhyp/platform-tracking';
import { ApplicationContext } from '@interhyp/util-application-context';
import { getConnection } from '@interhyp/util-request';
import { init as initTracking, TrackingAdapter, withTracking } from '@interhyp/util-tracking';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { Application } from './Application';
import { Footer } from './components/Footer/Footer';
import { LocalToggleProvider } from './provider/LocalToggleProvider';
import { Theme } from './provider/Theme';
import { IntentProvider } from './provider/intentProvider/IntentProvider';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
window.__conn = getConnection();
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
window.__conn.addHeader('Content-Type', 'application/json');

// Use interhyp profile for local development and for the interim portal stages
const isInterhyp =
  window.location.hostname === 'localhost' ||
  window.location.hostname.includes('portal-interim-home') ||
  window.location.hostname.includes('home.interhyp.de');

initTracking(undefined, isInterhyp ? isInterhyp : undefined);

const container = document.querySelector('#root');
const queryClient = new QueryClient();

const Shell = withTracking(
  {
    app: 'InterhypHome',
  },
  {
    dispatch: TrackingAdapter,
  },
)(ApplicationContainer);

if (container) {
  const root = createRoot(container);

  root.render(<Shell />);
}

function ApplicationContainer() {
  return (
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <MetaProvider
          stage={window.env?.stage ?? 'dev'}
          version={window.env?.version ?? 'local'}
          appType="portal"
        >
          <TrackingProvider application="portal-interim-home">
            <InternalTracking />
            <BrowserRouter>
              <DevtoolsProvider>
                <AuthenticationProvider>
                  <StorageProvider prefix="home">
                    <ApplicationContext>
                      <IntentProvider>
                        <LocalToggleProvider>
                          {toggles => (
                            <ModuleProvider modules={[]} toggles={[...toggles, 'home-only']}>
                              <Theme>
                                <FooterContext footer={<Footer />}>
                                  <NotificationProvider>
                                    <Application />
                                  </NotificationProvider>
                                </FooterContext>
                              </Theme>
                            </ModuleProvider>
                          )}
                        </LocalToggleProvider>
                      </IntentProvider>
                    </ApplicationContext>
                  </StorageProvider>
                </AuthenticationProvider>
              </DevtoolsProvider>
            </BrowserRouter>
          </TrackingProvider>
        </MetaProvider>
      </QueryClientProvider>
    </StrictMode>
  );
}
